import { Box } from "@mui/material";

import iconFieldworkerBike from "~/assets/images/icons/icon_fieldworker_bike.svg";
import iconFieldworkerCar from "~/assets/images/icons/icon_fieldworker_car.svg";
import iconFieldworkerCarMyWheels from "~/assets/images/icons/icon_fieldworker_mywheels.svg";
import iconFieldworkerPickUp from "~/assets/images/icons/icon_fieldworker_pick_up.svg";

const variantToImageMap: Record<string, string> = {
    bike: iconFieldworkerBike,
    myWheels: iconFieldworkerCarMyWheels,
    privateCar: iconFieldworkerCar,
    pickup: iconFieldworkerPickUp,
};

export function CheckboxFieldworker({
    variant,
    checked,
}: {
    variant: keyof typeof variantToImageMap;
    checked: boolean;
}) {
    return (
        <Box
            sx={theme => ({
                backgroundColor: checked ? theme.palette.primary.main : "transparent",
                borderRadius: 1,
                display: "flex",
                alignItems: "center",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: checked ? "none" : "#CBCBCB",
            })}
        >
            <img
                src={variantToImageMap[variant]}
                alt={variant}
                width={35}
                style={{ filter: checked ? "none" : "brightness(0) saturate(100%) invert(40%)" }}
            />
        </Box>
    );
}
